import { createContext } from 'react';

export const SigninContext = createContext({
  userName: '',
  customerName: '',
  setUserName: () => {},
  setCustomerName: () => {},
  setDisplayProfile: () => {},
  originalUserName: null,
  originalCustomerName: '',
  switchToOriginalUser: () => {}
});